import React from 'react';
import { Users, Network, Briefcase, Home, FolderGit2 } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';
import BranchIcon from '../../../assets/svg/BranchIcon';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    // { id: 'users', label: 'Users', icon: Users, path: '/users' },
    { id: 'connections', label: 'Connections', icon: Network, path: '/connections' },
    { id: 'jobs', label: 'Jobs', icon: Briefcase, path: '/jobs' },
    { id: 'repositories', label: 'Repositories', icon: BranchIcon, path: '/repositories' }
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="logo-icon">
          {/* <Home style={{ width: '1.458vw', height: '1.458vw' }} /> */}
          <img src="/parity_logo.svg" alt="DB Parity Logo" />
        </div>
        <span className="logo-text">DB Parity</span>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <div
              key={item.id}
              className={`nav-item ${isActive ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              <Icon className="nav-icon" style={{ width: '1.042vw', height: '1.042vw' }} />
              <span className="nav-label">{item.label}</span>
            </div>
          );
        })}
      </nav>

      {/* <div className="upgrade-card">
        <div className="upgrade-content">
          <h3>Upgrade to Pro</h3>
          <p>Unlock premium features and insights</p>
          <button className="learn-more-btn">Learn More</button>
        </div>
      </div> */}
    </div>
  );
};

export default Sidebar;
